export default __webpack_public_path__ + "static/media/i081sk.14ba0398.webp";